import { gql } from "@apollo/client";

export default gql`
  query getEmailAdminLogs($params: GetEmailAdminLogsInput!){
    getEmailAdminLogs(params: $params){
        success
        data{
            logs{
                _id
                customer
                customerName
                provider
                status
                from
                recipients{
                    to
                    cc
                    bcc
                    replyTo
                }
                subject
                templateId
                templateData
                html
                text
                attachments{
                    filename
                    contentType
                    size
                }
                metadata{
                    mailType
                }
                transportMessageId
                providerStatusCode
                errorMessage
                errorStack
                expiresAt
                createdAt
                updatedAt
            }
            total
        }
        code
        message
    }
}
`
